import script from "./SupplierInvoiceContact.vue?vue&type=script&lang=js"
export * from "./SupplierInvoiceContact.vue?vue&type=script&lang=js"

import "./SupplierInvoiceContact.vue?vue&type=style&index=0&id=15867f4f&lang=scss"

const __exports__ = script;

export default __exports__